module.exports = __webpack_public_path__ + "7b855dbb5c5f404d3af0c46defcecb9b.png";